import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=9eaca45e&scoped=true&"
import script from "./ProductInfo.vue?vue&type=script&lang=js&"
export * from "./ProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=9eaca45e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eaca45e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SizeSelect: require('/var/www/app/components/SizeSelect.vue').default,Btn: require('/var/www/app/components/Btn.vue').default,BtnFavorite: require('/var/www/app/components/BtnFavorite.vue').default,Product: require('/var/www/app/components/Product.vue').default})
